

import { request } from '@/utils/request'

// 分销活动
const distributeApi = {

  /** 获取活动列表 */
  getActivityList: params => request.get('distribute/distributeActivities/index', params),

  /** 新增活动 */
  addActivity: params => request.post('distribute/distributeActivities/store', params),

  /** 编辑活动 */
  updateActivity: (params: Recordable<any>, id) => request.put(`distribute/distributeActivities/update/${id}`, params),

  /** 获取活动详情 */
  getActivityDetail: id => request.get(`distribute/distributeActivities/detail/${id}`),

  // 海报列表
  getPosterList: params => request.get('distribute/distributePosters/index', params),

  // 添加海报
  addPoster: params => request.post('distribute/distributePosters/store', params),

  // 编辑海报
  updatePoster: (params, id) => request.put(`distribute/distributePosters/update/${id}`, params),

  /** 获取海报详情 */
  getPosterDetail: id => request.put(`distribute/distributePosters/detail/${id}`),

  // 分销管理列表
  getDistributeList: params => request.get('distribute/distributors/index', params),

  // 分销订单
  getDistributeOrderList: params => request.get('/distribute/distributionOrders/index', params),

  // 活动提现
  getOrderWithdrawalFlowFlowList: params => request.get('/distribute/distributionOrdersWithdrawalFlow/index', params),

  // 新增提现流水
  addOrderWithdrawal: params => request.get('/distribute/distributionOrders/orderWithdrawal', params),

  // 钱包提现记录
  getWalletWithdrawList: params => request.get('/distribute/distributorWalletWithdrawal/index', params),

  // 通过提现
  confirmWithdrawal: params => request.post('/distribute/distributorWalletWithdrawal/confirm', params),

  // 拒绝提现
  rejectWithdrawal: params => request.post('/distribute/distributorWalletWithdrawal/reject', params),

  // 查询分销商分享的用户列表
  getDistributeJoiner: params => request.get('/distribute/distributeJoiners/index', params),

  /**
   * 分销商接口
   */
  // 查询分销商海报
  getDistributorPosterList: params => request.get('/distribute/distributorPosters/index', params),

  // 查询B端分销海报邀请列表
  getDistributorPosterJoiner: params => request.get('/distribute/distributeJoiners/index', params),

  // 查询C端分销海报邀请列表
  getDistributorConsumePosterJoiner: params => request.get('/distribute/distributeConsumeJoiners/index', params),

  // 查询C端二级分销海报邀请列表
  getDistributorSubConsumePosterJoiner: params => request.get('/distribute/distributorPosterOrders/index', params),

  exportReport: params => request.post('/distribute/distributorPosters/exportReport', params),

  exportList: params => request.get('/distribute/distributeReports/index', params)

}

export { distributeApi }


